import { environment } from "@/config/environment";
import axios, { AxiosInstance } from "axios";

export class IFramelyApi {
  axiosInstance: AxiosInstance | undefined;

  constructor() {}

  async iframely(url: string) {
    return await axios.request({
      method: 'get',
      maxBodyLength: Infinity,
      // url: `https://iframely.findify.cloud/iframely?url=${url}`,
      url: `${environment.IFRAMELY_API_URL}/iframely?url=${url}`,
      headers: {}
    })
  };

  async oembed(url: string) {
    return await axios.request({
      method: 'get',
      maxBodyLength: Infinity,
      // url: `https://iframely.findify.cloud/oembed?url=${url}`,
      url: `${environment.IFRAMELY_API_URL}/oembed?url=${url}`,
      headers: {}
    })
  };

};
